import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["rowspan"]
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = {
  class: "text-no-wrap",
  style: {"font-size":"60%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("td", {
    cols: "5",
    rowspan: _ctx.rowspan,
    style: {"width":"8%"}
  }, [
    _createVNode(_component_v_btn, {
      disabled: _ctx.disable,
      height: "130%",
      width: "100%",
      onClick: _ctx.select,
      color: _ctx.selectedPosIndexes.has(_ctx.position.posIndex)? 'lime-accent-1' :'' 
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.position.votes)
            ? (_openBlock(), _createBlock(_component_v_badge, {
                key: 0,
                overlap: "",
                content: _ctx.position.votes,
                value: _ctx.position.votes
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_avatar, { size: "40" }, {
                    default: _withCtx(() => [
                      (_ctx.position.player)
                        ? (_openBlock(), _createBlock(_component_v_img, {
                            key: 0,
                            src: _ctx.position.player.avatar
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_v_img, {
                            key: 1,
                            src: _ctx.avatar
                          }, null, 8, ["src"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content", "value"]))
            : (_openBlock(), _createBlock(_component_v_avatar, {
                key: 1,
                size: "40"
              }, {
                default: _withCtx(() => [
                  (_ctx.position.player)
                    ? (_openBlock(), _createBlock(_component_v_img, {
                        key: 0,
                        src: _ctx.position.player.avatar
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_v_img, {
                        key: 1,
                        src: _ctx.avatar
                      }, null, 8, ["src"]))
                ]),
                _: 1
              })),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.position.player?.name), 1)
        ])
      ]),
      _: 1
    }, 8, ["disabled", "onClick", "color"])
  ], 8, _hoisted_1))
}